import styled from 'styled-components';

export const DrawerFilterContainer = styled.div`
  padding: 3rem;

  [class*='FieldWrapperstyle__Label-sc-'] {
    font-weight: 700;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AppliedFiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const FilterPillContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const ClearFiltersLink = styled.div`
  text-decoration: underline;
  cursor: pointer;
  user-select: none;
`;

export const ButtonGroupContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.625rem;
`;
